import { createFileRoute, Navigate } from '@tanstack/react-router';

import { SlackIntegrationCard } from '@apps/web/components/settings/slack_integration_card';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/slack')({
    component: SlackPage,
});

function SlackPage() {
    const { organizationId, gates } = useSettingsGates();
    if (!gates.canManageOrgSettings || !gates.slack) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }
    return (
        <SettingsPageShell
            title="Slack"
            description="Connect Slack for notifications."
        >
            <SlackIntegrationCard organizationId={organizationId} />
        </SettingsPageShell>
    );
}
